import { AlerteDto, ParcActifDto, ParcDetailsDto, ParcLimitropheForConfigurationDto, TypeDechetParcDto, TypeEvacuationDto } from "src/api/models";
import { OuvertureParc } from "src/core/models/OuvertureParc";

export interface ParcsState {
  parcsActifs: ParcActifDto[];
  parc: ParcDetailsDto,
  parcsLimitrophes: ParcLimitropheForConfigurationDto[];
  heuresOuverture: OuvertureParc[];
  visitesDuJour: number;
  alerte: AlerteDto,
  typesDechetsParcNoDestination: TypeDechetParcDto[];
  typesEvacuationParcNoDestination: TypeEvacuationDto[];
  error: string;
}

export const ParcsStateDefault = {
  parcsActifs: null,
  parc: null,
  parcsLimitrophes: null,
  heuresOuverture: null,
  visitesDuJour: null,
  alerte: null,
  typesDechetsParcNoDestination: null,
  typesEvacuationParcNoDestination: null,
  error: null
};

